/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { Button } from 'react-bootstrap';
import _ from 'lodash';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
// custom component import
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
// custom function import
import {
  drugFamilyTableData,
  planTypeData,
  drugData,
  manuFactureHead,
  clearCellErrors,
} from './utils';
import createIcon from '../../../../assets/images/feather-settings.svg';
import {
  getDrugFamily,
  getManufacturerGrid,
  getRebatePriceLevelDetailsApi,
  getRebatePrograms,
  storePriceDetailErrors,
  storePriceDetailsInputData,
  storePriceLevelErrors,
  storePriceLevelSearchData,
  dispatchManufactGrid,
  dispatchDrugFamilyGrid,
  getPlanTypeDesc,
} from '../store/actions';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import {
  MNFC_NDC_ERROR_MSG,
  SUCCESS_MSG,
} from '../../../../SharedModules/Errors/constantMessageData';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import {
  autoFormateDate,
  tabHighLigther,
} from '../../../../SharedModules/utilities/utilities';
import {
  checkQuarterValidation,
  handleScrollToEvent,
  isArr,
  redirectURLLink,
} from '../../../../SharedModules/CommonUtilities/commonUtilities';

function PriceLevelSearch() {
  const dispatch = useDispatch();
  const history = useHistory();
  // use Selector function
  const getInputValues = useSelector(
    (state) => state.sharedState.PriceLevel.priceLevelSearchdata
  );
  const errorMessagesFromRedux = useSelector(
    (state) => state.sharedState.PriceLevel.priceLevelErrors
  );
  const manufacturerGrid = useSelector(
    (state) => state.sharedState.PriceLevel.manufacturerGrid
  );
  const drugFamilyArr = useSelector(
    (state) => state.sharedState.PriceLevel.drugFamily
  );
  const spinnerLoader = useSelector((state) => {
    return state?.sharedState.showPreLoader?.showPreLoader;
  });
  const detailPageValues = useSelector(
    (state) => state.sharedState.PriceLevel.priceDetailsInputData
  );
  const overlapStateErr = useSelector(
    (state) => state.sharedState.PriceLevel.overlapStateErr
  );
  const blurPageState = useSelector(
    (state) => state.sharedState.PriceLevel.blurPageState
  );

  // variable deceleration
  const gridRef = React.useRef();
  const [fullScreenView1, setFullScreenView1] = React.useState(false);
  const [fullScreenView2, setFullScreenView2] = React.useState(false);
  const [gridParams, setGridParams] = React.useState(null);
  const [gridParams2, setGridParams2] = React.useState(null);
  const [inputValues, setInputValues] = React.useState(getInputValues);
  const [rebatePgmList, setRebatePgmList] = React.useState([]);
  const drug = inputValues.drugFamily === 'drug';

  // handling onPage load call service
  React.useEffect(() => {
    handleScrollToEvent();
  }, []);

  React.useEffect(() => {
    setInputValues({ ...inputValues, drugFamilyArr });
  }, [drugFamilyArr]);

  // validate, API call & then go to details page
  const handleProcess = async () => {
    const detailsObj = {
      rebateProgramCd: inputValues.rebateProgramCd,
      qtr: inputValues.quarterValue,
      mfgId: inputValues.mfgId,
      drugfamilyId: drug ? getInputValues.drugfamilyId : -1,
    };
    let localErr = [...errorMessagesFromRedux];
    if (
      inputValues?.rebateProgramCd !== null &&
      inputValues?.rebateProgramCd !== '-1' &&
      checkQuarterValidation(inputValues.quarterValue)
    ) {
      clearCellErrors(blurPageState, overlapStateErr, dispatch);
      dispatch(storePriceDetailErrors([]));
      const temp = await dispatch(getRebatePriceLevelDetailsApi(detailsObj));
      const { message, rebateProgramLevel } = temp.payload;
      if (message === SUCCESS_MSG) {
        if (
          rebateProgramLevel.length > 0 &&
          rebateProgramLevel[0]?.getDetailsHeader?.length > 0
        ) {
          dispatch(
            storePriceLevelSearchData({
              ...getInputValues,
              loadDrugTable: false,
            })
          );
          await dispatch(getPlanTypeDesc(getInputValues.planType));
          dispatch(
            storePriceDetailsInputData({
              ...detailPageValues,
              pageCount: 1,
              counter: 0,
              rowsChanged: true,
              resetRowData: true,
            })
          );
          tabHighLigther('/priceLevel', false);
          redirectURLLink(
            '/priceDetails',
            'Maintain Rebate Price Details',
            history,
            dispatch
          );
        }
      }
    } else if (
      inputValues.rebateProgramCd === null ||
      inputValues.rebateProgramCd === '-1'
    ) {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    } else if (inputValues.quarterValue === '') {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(inputValues.quarterValue)) {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }
    if (localErr && !localErr.length > 0) {
      tabHighLigther('/priceLevel', false);
    }
    dispatch(storePriceLevelErrors([...new Set(localErr)]));
  };
  // handling On change event on filed level
  const handleOnChangeEvent = (value, name) => {
    let localErr = errorMessagesFromRedux || [];
    if (name === 'planType') {
      localErr = localErr.filter(
        (item) =>
          item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
      );
      dispatch(dispatchManufactGrid([]));
      dispatch(dispatchDrugFamilyGrid([]));
      setInputValues({ ...inputValues, [name]: value, rebateProgramCd: '-1' });
      dispatch(
        storePriceLevelSearchData({
          ...inputValues,
          [name]: value,
          rebateProgramCd: '-1',
        })
      );
    } else {
      setInputValues({ ...inputValues, [name]: value });
      dispatch(storePriceLevelSearchData({ ...inputValues, [name]: value }));
    }
    dispatch(storePriceLevelErrors([...new Set(localErr)]));
  };
  //  handling On blur event on filed level
  const handleOnblurEvent = async (type, value) => {
    let localErr = [...errorMessagesFromRedux];
    if (type === 'rebateProgramCd') {
      if (!value || value === '-1') {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'rebateProgramCd',
          errorType: 'rebateRequired',
          message: constantMessageData.REBATE_PROGRAM_REQUIRED,
        });
      } else {
        localErr = localErr.filter(
          (item) =>
            item.field !== 'rebateProgramCd' && item.field !== 'resultNotFound'
        );
      }
    }
    if (type === 'quarter') {
      if (value && !_.isEmpty(value) && !_.isNaN(value)) {
        localErr = localErr?.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        if (checkQuarterValidation(value)) {
          localErr = localErr?.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          setInputValues({
            ...inputValues,
            quarterValue: autoFormateDate(value?.toUpperCase()),
          });
          dispatch(
            storePriceLevelSearchData({
              ...inputValues,
              quarterValue: autoFormateDate(value?.toUpperCase()),
            })
          );
        } else {
          localErr = localErr.filter(
            (item) =>
              item.field !== 'quarter' && item.field !== 'resultNotFound'
          );
          localErr.push({
            field: 'quarter',
            errorType: 'invalidFormat',
            message: constantMessageData.INVALID_QTR_ERR_MSG,
          });
        }
      } else {
        localErr = localErr.filter(
          (item) => item.field !== 'quarter' && item.field !== 'resultNotFound'
        );
        localErr.push({
          field: 'quarter',
          errorType: 'required',
          message: constantMessageData.QUARTER_VALUE_REQUIRED,
        });
      }
    }
    if (localErr && localErr?.length === 0) {
      await handleManufacturerGridList(
        '',
        type === 'quarter'
          ? {
              ...inputValues,
              quarterValue: autoFormateDate(value?.toUpperCase()),
            }
          : { ...inputValues, rebateProgramCd: value }
      );
      //setTimeout(() => {
        onGridReady(gridParams);
      //}, 1000);
      //setTimeout(() => {
        onGridReadyDrugFamily(gridParams2);
      //}, 1500);
    }
    dispatch(storePriceLevelErrors([...new Set(localErr)]));
  };
  // set full screen click icon button
  const handleFullScreenView = (key) => {
    if (key === 1) {
      setFullScreenView1(!fullScreenView1);
    } else {
      setFullScreenView2(!fullScreenView2);
    }
  };
  // selected rebate program and quarter filed after call API service
  const handleManufacturerGridList = async (dFamily = '', data) => {
    let localErr = [];
    if (
      data?.rebateProgramCd !== null &&
      data?.rebateProgramCd !== '-1' &&
      checkQuarterValidation(data.quarterValue)
    ) {
      const val = {
        rebateProgramCd: data.rebateProgramCd,
        qtr: data.quarterValue,
        mfgTypeCd: 'C',
      };
      handleClearFilter();
      const result = await dispatch(getManufacturerGrid(val));
      if (!(result.payload?.length > 0)) {
        localErr.push({
          field: 'resultNotFound',
          errorType: 'resultNotFound',
          message: constantMessageData.MNFC_NDC_ERROR_MSG,
        });
        dispatch(dispatchDrugFamilyGrid([]));
        handleScrollToEvent();
        if (dFamily === '') {
          setInputValues({
            ...data,
            drugFamilyArr: [],
          });
        } else {
          setInputValues({
            ...data,
            drugFamily: dFamily,
            drugFamilyArr: [],
          });
        }
      }
    } else if (data.rebateProgramCd === null || data.rebateProgramCd === '-1') {
      localErr = localErr?.filter((item) => item.field !== 'rebateProgramCd');
      localErr.push({
        field: 'rebateProgramCd',
        errorType: 'rebateRequired',
        message: constantMessageData.REBATE_PROGRAM_REQUIRED,
      });
    } else if (data.quarterValue === '') {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'required',
        message: constantMessageData.QUARTER_VALUE_REQUIRED,
      });
    } else if (!checkQuarterValidation(data.quarterValue)) {
      localErr = localErr.filter((item) => item.field !== 'quarter');
      localErr.push({
        field: 'quarter',
        errorType: 'invalidFormat',
        message: constantMessageData.REQUEST_DATE_INVALID_FORMAT_CBI,
      });
    }
    if (localErr && !localErr.length > 0) {
      tabHighLigther('/priceLevel', false);
    }
    dispatch(storePriceLevelErrors([...new Set(localErr)]));
  };
  // click on filter icon after call
  const handleClearFilter = () => {
    if (gridRef !== null) {
      gridRef.current.clearFilters();
      if (gridParams?.columnApi && gridParams?.columnApi !== null) {
        gridParams.columnApi.applyColumnState({
          state: [{ colId: 'mfgId', sort: 'asc' }],
        });
      }
    }
  };
  React.useEffect(() => {
    // handleManufacturerGridList('', inputValues);
  }, [inputValues.rebateProgramCd]);

  //  tab highliter Functionality
  React.useEffect(() => {
    if (errorMessagesFromRedux.length > 0) {
      tabHighLigther('/priceLevel', true);
    } else {
      tabHighLigther('/priceLevel', false);
    }
  }, [JSON.stringify(errorMessagesFromRedux)]);

  React.useEffect(() => {
    if (getInputValues.loadDrugTable && manufacturerGrid?.length > 0) {
      dispatch(
        getDrugFamily({
          mfgId: getInputValues.mfgId,
          qtr: inputValues.quarterValue,
          rebateProgramCd: inputValues.rebateProgramCd,
        })
      );
    }
  }, [getInputValues.loadDrugTable]);

  const refreshDrugFamily = async () => {
    if (!drug && manufacturerGrid?.length > 0) {
      await dispatch(
        getDrugFamily({
          mfgId: getInputValues.mfgId,
          qtr: inputValues.quarterValue,
          rebateProgramCd: inputValues.rebateProgramCd,
        })
      );
      //setTimeout(() => {
        onGridReadyDrugFamily(gridParams2, true);
      //}, 2000);
    }
  };

  React.useEffect(() => {
    refreshDrugFamily();
  }, []);

  React.useEffect(() => {
    if (inputValues?.planType) {
      getRebatePrograms(inputValues?.planType).then((res) =>
        setRebatePgmList(res)
      );
    }
  }, [inputValues?.planType]);

  // to select by default 1st row
  const onGridReady = (params, dF = getInputValues.drugFamily) => {
    const arr = [];
    if (params) {
      if (getInputValues.loadMfgGrid) {
        params.api.forEachNode((node) => arr.push(node.data));
        if (arr.length) {
          setInputValues((prev) => ({
            ...prev,
            mfgId: arr[0]?.mfgId,
          }));
          dispatch(
            storePriceLevelSearchData({
              ...getInputValues,
              drugFamily: dF,
              mfgId: arr[0]?.mfgId,
              loadDrugTable: true,
            })
          );
        }
        params.api.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
      } else {
        const gridRowSelect = manufacturerGrid?.findIndex(
          (obj) => obj['mfgId'] === getInputValues.mfgId
        );
        params.api.forEachNode(
          (node) => node?.rowIndex === gridRowSelect && node?.setSelected(true)
        );
      }
      setGridParams(params);
    }
  };

  const onGridReadyDrugFamily = (params, selectFirstRow) => {
    let arr = [];
    if (params) {
      if (getInputValues.loadDrugFamilyGrid || selectFirstRow) {
        params.api.forEachNode(
          (node) => node?.rowIndex === 0 && node?.setSelected(true)
        );
      } else {
        const gridRowSelect = drugFamilyArr
          ?.sort((a, b) => a.familySeqNum - b.familySeqNum)
          .findIndex(
            (obj) => obj['familySeqNum'] === getInputValues.drugfamilyId
          );
        params.api.forEachNode(
          (node) => node?.rowIndex === gridRowSelect && node?.setSelected(true)
        );
      }
      params.api.forEachNode((node) => arr.push(node.data));
      if (arr.length) {
        setInputValues((prev) => ({
          ...inputValues,
          drugfamilyId: arr[0].familySeqNum,
        }));
      }
      setGridParams2(params);
    }
  };

  React.useEffect(() => {
    if (drugFamilyArr?.length > 0) {
      //setTimeout(() => {
        onGridReadyDrugFamily(gridParams2, true);
      //}, 300);
    }
  }, [drugFamilyArr]);

  return (
    <div className="tabs-container" data-testid="price_level_container">
      <Spinner load={spinnerLoader} />
      {!fullScreenView1 && !fullScreenView2 && (
        <>
          <CustomSeparator
            parent1="Maintain"
            parent2="Search Rebate Price Level"
          />
          <DisplayErrorMessages
            errorMessages={[
              ...new Set(
                errorMessagesFromRedux?.length > 0
                  ? _.map(errorMessagesFromRedux, (l) => l.message)
                  : []
              ),
            ]}
          />
          <div className="row">
            <div className="col-sm-6 col-md-6 col-lg-4">
              <RadioGroupComponent
                data-testid="radio-box-change-control"
                style={{ width: '40%' }}
                labelName="Plan Type"
                required
                reqColor
                optionList={planTypeData}
                defaultValue={inputValues.planType}
                filterAction={(e) => {
                  handleOnChangeEvent(e, 'planType');
                }}
                className="log-batch-filter-radio"
              />
            </div>

            {/* REBATE PROGRAM DROPDOWN */}
            <div className="col-sm-6 col-md-6 col-lg-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Rebate Program &nbsp;
                  <span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper db p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="rebateProgram"
                      id="rebate_program"
                      data-testid="rebate-program"
                      label="Rebate Program"
                      fullWidth
                      select
                      required
                      placeholder=""
                      inputProps={{ maxLength: 11, id: 'rebate_program' }}
                      onBlur={(e) =>
                        handleOnblurEvent('rebateProgramCd', e.target.value)
                      }
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={inputValues && inputValues.rebateProgramCd}
                      onChange={(e) =>
                        handleOnChangeEvent(e.target.value, 'rebateProgramCd')
                      }
                      className={
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'rebateProgramCd'
                                ? 'mandate-fields'
                                : null
                            )
                          : null
                      }
                      helperText={
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'rebateProgramCd' ? l.message : null
                            )
                          : null
                      }
                    >
                      <MenuItem
                        key=""
                        value="-1"
                        className="frr-dropdown-blank-item"
                      />
                      {isArr(rebatePgmList)
                        ? rebatePgmList.map((item) => {
                            return (
                              <MenuItem key={item.id} value={item.id}>
                                {item.name}
                              </MenuItem>
                            );
                          })
                        : null}
                    </TextField>
                  </div>
                </div>
              </fieldset>
            </div>

            {/* QUARTER */}
            <div className="col-sm-6 col-md-6 mt-sm-3 mt-lg-0 col-lg-4">
              <fieldset className="custom-fieldset">
                <legend className="same-font-family">
                  Quarter &nbsp;
                  <span className="mandatory"> *</span>
                </legend>
                <div className="form-wrapper p-0">
                  <div className="mui-custom-form with-select field-xl no-lbl">
                    <TextField
                      name="quarter"
                      data-testid="quarter"
                      label="quarter"
                      id="quarter_pricelevel"
                      fullWidth
                      placeholder=""
                      inputProps={{ maxLength: 6, id: 'quarter_pricelevel' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={inputValues && inputValues.quarterValue}
                      onChange={(e) => {
                        handleOnChangeEvent(e.target.value, 'quarterValue');
                      }}
                      onBlur={(e) =>
                        handleOnblurEvent('quarter', e.target.value)
                      }
                      className={
                        errorMessagesFromRedux?.length > 0
                          ? _.map(errorMessagesFromRedux, (l) =>
                              l.field === 'quarter' ? 'mandate-fields' : null
                            )
                          : null
                      }
                      helperText={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'quarter' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                      error={[
                        ...new Set(
                          errorMessagesFromRedux?.length > 0
                            ? _.map(errorMessagesFromRedux, (l) =>
                                l.field === 'quarter' ? l.message : null
                              )
                            : null
                        ),
                      ]}
                    />
                  </div>
                </div>
              </fieldset>
            </div>
          </div>

          {/* SELECT DRUG FAMILY  */}
          <div className="row mt-4 frr-two-col-radio">
            <div className="col-sm-12 ">
              <RadioGroupComponent
                data-testid="drug_family"
                labelName="Select Drug Family Options"
                required={false}
                optionList={drugData}
                defaultValue={getInputValues.drugFamily}
                filterAction={async (e) => {
                  setInputValues({ ...inputValues, drugFamily: e });
                  let temp = [...errorMessagesFromRedux];
                  temp = temp.filter((x) => x.message !== MNFC_NDC_ERROR_MSG);
                  await dispatch(storePriceLevelErrors(temp));
                  await dispatch(
                    storePriceLevelSearchData({
                      ...getInputValues,
                      drugFamily: e,
                    })
                  );
                  if (
                    inputValues?.rebateProgramCd !== null &&
                    inputValues?.rebateProgramCd !== '-1' &&
                    checkQuarterValidation(inputValues.quarterValue)
                  ) {
                    //setTimeout(() => {
                      onGridReady(gridParams, e);
                    //}, 1500);
                  }
                  handleManufacturerGridList(e, {
                    ...inputValues,
                    drugFamily: e,
                  });
                }}
                className="log-batch-filter-radio"
              />
            </div>
          </div>

          <div className="flex-block justify-end mt-2 mb-10">
            <Button
              className="btn-success same-font-family frr-btn-width-17 mt-4"
              data-testid="price_level_process"
              type="button"
              onClick={handleProcess}
            >
              <img className="manufactureImg" alt="" src={createIcon} />
              Process
            </Button>
          </div>
        </>
      )}

      {/* MANUFACTURER GRID */}
      <div className="row row_wrap">
        {!fullScreenView2 && (
          <div
            className={`col-${!fullScreenView1 ? 'sm-6' : 'sm-12'} mt-4`}
            data-testid="manufacturer-grid"
          >
            <TableGrid
              ref={gridRef}
              gridCall={onGridReady}
              rowData={
                getInputValues.rebateProgram !== '-1' ? manufacturerGrid : []
              }
              columnDefs={manuFactureHead}
              handleFullScreenViewClick={() => handleFullScreenView(1)}
              fullScreenView={fullScreenView1}
              gridHeight={fullScreenView1 ? '70vh' : 400}
              enterMovesDown
              suppressCellFocus
              exportFile
              data-testid="onEditingStopped"
              fileName="Manufacturer"
              helpMessage="Manufacturer Selection"
              onSelect={(e) => {
                setInputValues({
                  ...inputValues,
                  mfgId: e.data?.mfgId || '',
                  drugfamilyId: null,
                });
                dispatch(
                  storePriceLevelSearchData({
                    ...getInputValues,
                    loadMfgGrid: false,
                    mfgId: e.data?.mfgId || '',
                  })
                );
                if (drug) {
                  dispatch(
                    getDrugFamily({
                      mfgId: e.data?.mfgId,
                      qtr: inputValues.quarterValue,
                      rebateProgramCd: inputValues.rebateProgramCd,
                    })
                  );
                }
              }}
              cellClickedListener={(e) => {
                if (!drug) {
                  handleProcess();
                }
              }}
            />
          </div>
        )}

        {/* DRUG FAMILY GRID */}
        {!fullScreenView1 && drug && (
          <div className={`col-${!fullScreenView2 ? 'sm-6' : 'sm-12'} mt-4`}>
            <TableGrid
              rowData={
                manufacturerGrid?.length > 0
                  ? drugFamilyArr?.sort(
                      (a, b) => a.familySeqNum - b.familySeqNum
                    )
                  : []
              }
              gridCall={onGridReadyDrugFamily}
              columnDefs={drugFamilyTableData}
              handleFullScreenView={false}
              handleFullScreenViewClick={() => handleFullScreenView(2)}
              fullScreenView={fullScreenView2}
              gridHeight={fullScreenView2 ? '70vh' : 400}
              enterMovesDown
              suppressCellFocus
              exportFile
              data-testid="drug_family_grid"
              fileName="Drug_Family"
              helpMessage="Drug Family Selection"
              onSelect={(e) => {
                setInputValues({
                  ...inputValues,
                  drugfamilyId: e.data?.familySeqNum,
                });
                dispatch(
                  storePriceLevelSearchData({
                    ...getInputValues,
                    loadDrugFamilyGrid: false,
                    drugfamilyId: e.data?.familySeqNum,
                  })
                );
              }}
              cellClickedListener={(e) => {
                setInputValues({
                  ...inputValues,
                  drugfamilyId: e.data?.familySeqNum,
                });
                handleProcess();
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default PriceLevelSearch;
